module.exports = __webpack_public_path__ + "static/media/WendellDavis2.8204f58a.jpg";